import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { breakpoints } from '@infl-ts/util-block-width-context';
import { Box, styled, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Overlay = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:after {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      to right,\n      transparent 90%,\n      97%,\n      ", "\n    );\n  }\n"])), function (p) {
  return p.theme.palette.background["default"];
});

var ScrollableChallenges = function ScrollableChallenges(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'relative',
      width: 1,
      maxWidth: "".concat(breakpoints['md'], "px"),
      overflow: 'hidden'
    },
    "data-element": "Box",
    "data-component": "ScrollableChallenges",
    "data-source-file": "scrollable-challenges.tsx",
    children: [title && /*#__PURE__*/_jsx(Typography, {
      variant: "h2",
      sx: {
        mb: 2
      },
      children: title
    }), /*#__PURE__*/_jsx(Overlay, {
      sx: {
        overflowX: 'scroll',
        pr: 4
      },
      "data-element": "Overlay",
      "data-component": "ScrollableChallenges",
      "data-source-file": "scrollable-challenges.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          gap: function gap(t) {
            return t.spacing(2.5);
          },
          width: 'fit-content',
          justifyContent: 'row',
          py: 0.5,
          px: 0.25
        },
        "data-element": "Box",
        "data-component": "ScrollableChallenges",
        "data-source-file": "scrollable-challenges.tsx",
        children: children
      })
    })]
  });
};

export default ScrollableChallenges;